import React from "react";

const OnboardArrow = ({
  width = 44,
  height = 44,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1651_16796)">
        <rect x="2" y="1" width="40" height="40" rx="20" fill="white" />
        <rect
          x="2.5"
          y="1.5"
          width="39"
          height="39"
          rx="19.5"
          stroke="#E2E4E9"
        />
        <path
          d="M25.129 20.2515L21.106 16.2285L22.1665 15.168L28 21.0015L22.1665 26.835L21.106 25.7745L25.129 21.7515H16V20.2515H25.129Z"
          fill="#525866"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1651_16796"
          x="0"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1651_16796"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1651_16796"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default OnboardArrow;
